import React from 'react';
import { motion } from 'framer-motion';
export function Hook() {
  return <section className="bg-warm-white py-20 md:py-28" data-id="element-173">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-175">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal mb-10 leading-tight" data-id="element-176">
            No era falta de disciplina.
          </h2>

          <div className="space-y-6 text-lg md:text-xl lg:text-2xl text-charcoal/80 leading-relaxed" data-id="element-177">
            <p data-id="element-178">Tal vez llevas años intentando hacer "todo bien".</p>
            <p className="font-serif italic text-forest" data-id="element-179">
              Comer menos. Exigirte más. Empezar otra vez cada lunes.
            </p>
            <p data-id="element-180">
              Pero después de los 40, muchas mujeres descubren que su cuerpo{' '}
              <strong className="text-charcoal" data-id="element-181">
                responde de manera diferente
              </strong>
              .
            </p>
            <p className="font-serif italic text-xl md:text-2xl lg:text-3xl text-charcoal pt-4" data-id="element-182">
              Y entender eso puede cambiar completamente la forma en que se
              sienten consigo mismas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}